import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef
} from '@angular/material';

import { BilSnackbarComponent } from '@core/components/bil-snackbar/bil-snackbar.component';
import { BilEventBrokerService } from '@app/core/services/bil-event-broker/bil-event-broker.service';
import { BilEventSnackbarOpen } from '@app/core/services/bil-event-broker/bil-event-broker-arguments/bil-event-snackbar-open';
import { BilEventSnackbarClose } from '@app/core/services/bil-event-broker/bil-event-broker-arguments/bil-event-snackbar-close';
import { BilSnackbarConfigService } from '@core/configs/bil-snackbar-config.service';

@Injectable({
  providedIn: 'root'
})
export class BilSnackbarService {
  public snackBarRef: MatSnackBarRef<any>;

  constructor(private snackBar: MatSnackBar, private eventBroker: BilEventBrokerService,
    private snackbarConfigService: BilSnackbarConfigService) {
  }
  startListening(): void {
    this.eventBroker.subscribe((event: BilEventSnackbarOpen) => {
      this.close();
      if (event.duration) {
        this.open(event.message, event.type, event.duration);
      } else {
        this.open(event.message, event.type);
      }
    }, BilEventSnackbarOpen.EventSelector);

    this.eventBroker.subscribe((event: BilEventSnackbarClose) => {
      this.close();
    }, BilEventSnackbarClose.EventSelector);
  }

  private open(
    message: string,
    type: string,
    duration?: number
  ) {
    const config: MatSnackBarConfig = this.snackbarConfigService.getSnackbarConfig();
    config.duration = duration ? duration : config.duration;
    config.data = { text: message, type: type };
    config.panelClass = ['bil-snackbar-' + type];
    this.snackBarRef = this.snackBar.openFromComponent(
      BilSnackbarComponent,
      config
    );
  }

  private close() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }
}
